module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-quote-65ef4f009b240e5b3141b03729e98a1b.svg";